import { Box } from '@wix/design-system'
import React, { FC, memo, ReactNode } from 'react'

type InCircleProps = {
  fill?: boolean
  children?: ReactNode
}

export const InCircle: FC<InCircleProps> = memo(({ children, fill }) => (
  <Box
    align="center"
    verticalAlign="middle"
    backgroundColor={fill ? 'B10' : 'D80'}
    borderRadius="100%"
    borderWidth={1}
    borderStyle="solid"
    borderColor="B10"
    width={30}
    height={30}
    children={children}
  />
))
